import { useMemo } from "react";

import { formatAwsDateString, formatCurrency } from "@covertree/utils";
import { Row } from "@covertree/ui/table/types";

import { useOpenPolicyDetails } from "@hooks/actions/useOpenPolicyDetails";
import { mapPolicyStatus } from "@utils/mapPolicyStatus";
import { formatProductTypeName } from "@utils/formatPolicyType";

import { PendingCancellationPolicyListItemFragment } from "@covertree/agent-portal-graphql";

export const useMappedPendingCancellationPolicies = (
  policies: PendingCancellationPolicyListItemFragment[] | undefined
) => {
  const openPolicyDetails = useOpenPolicyDetails();

  return useMemo(() => {
    if (!policies) {
      return [];
    }
    return policies.map<Row>(({ previousAddress: address, ...policy }) => ({
      id: policy.policyLocator,
      data: [
        policy.policyLocator,
        `${policy.policyholder.firstName} ${policy.policyholder.lastName}`,
        [
          address.streetAddress,
          address.city,
          address.state,
          address.zipCode,
        ].join(" "),
        formatProductTypeName(policy.productTypeName),
        formatCurrency(policy.units[0].pricing.grossPremium),
        formatAwsDateString(policy.cancellationEffectiveDate),
        mapPolicyStatus(policy.status),
        policy.description,
        [
          formatAwsDateString(policy.startDate),
          formatAwsDateString(policy.endDate),
        ].join(" - "),
        policy.agencyInformation.agentName,
        policy.agencyInformation.agencyName,
        formatAwsDateString(policy.updatedDate),
      ],
      onClickRow: () => openPolicyDetails(policy.policyLocator),
      actionMenuItems: [
        {
          label: "View details",
          onClick: () => openPolicyDetails(policy.policyLocator),
        },
      ],
    }));
  }, [policies]);
};
